import { APIRoute } from 'routes/api'
import { REQUEST_METHOD } from 'utils/apiClient'
import { createApiThunk } from 'utils/thunkWrapper'

export const createCognitoUser = createApiThunk<CognitoUser, CognitoUserCreatePayload>({
  action: 'cognitoUser/create',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_CREATE_COGNITO_USER,
  getData: (payload) => payload,
})

export const getCognitoUsers = createApiThunk<CognitoUsersByGroupResponse, CognitoUsersByGroupPayload>({
  action: 'cognitoUser/get',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_COGNITO_USERS,
  getParams: (payload) => payload,
})

export const deleteCognitoUser = createApiThunk<void, CognitoDeleteUserPayload>({
  action: 'cognitoUser/delete',
  method: REQUEST_METHOD.DELETE,
  formatUrl: () => APIRoute.DELETE_COGNITO_USER,
  getParams: (payload) => payload,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const resendCognitoInvitation = createApiThunk<void, CognitoResendInvitationPayload>({
  action: 'cognitoUser/resend',
  method: REQUEST_METHOD.POST,
  formatUrl: (payload) => APIRoute.POST_RESEND_COGNITO_INVITATION(payload.email),
  getSuccessMessage: (payload) => payload.successMessage,
})

export const editCognitoUser = createApiThunk<void, CognitoUserEditPayload>({
  action: 'cognitoUser/edit',
  method: REQUEST_METHOD.PUT,
  formatUrl: () => APIRoute.PUT_EDIT_COGNITO_USER,
  getData: (payload) => payload,
  getSuccessMessage: (payload) => payload.successMessage,
})
